module.exports = __webpack_public_path__ + "static/media/select-arrow.13483ac3.svg";